<template>
    <div class="clock-label">
        {{ datetime }}
    </div>
</template>
<script lang="tsx" setup>
import Tools from '@/utils/Tools';
import { onMounted, ref } from 'vue';
const datetime = ref<string>('');
function GetTime(){
     const time = Date.now();
     datetime.value = Tools.ConvertTimestamp(time,'America/New_York','MM-DD HH:mm:ss');
     setTimeout(() => {
        GetTime();
     }, 1000);
}
onMounted(()=>{
    GetTime();
})
</script>

<style scoped lang="scss">
.clock-label{
    font-weight: bold;
}
</style>